__turbopack_context__.v({
  "root": "styles-module-scss-module__MnUJ4a__root",
});
